import { render, staticRenderFns } from "./VideoView.vue?vue&type=template&id=004f11c4&scoped=true"
import script from "./VideoView.vue?vue&type=script&lang=js"
export * from "./VideoView.vue?vue&type=script&lang=js"
import style0 from "./VideoView.vue?vue&type=style&index=0&id=004f11c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f11c4",
  null
  
)

export default component.exports